import { makeAutoObservable } from 'mobx'

import { TariffApi } from 'shared/api/TariffApi'
import { getApiErrorMessage } from 'shared/lib/errorText'
import { TicketItem } from 'shared/models/ticket'

import { TariffTicketModel } from './model'

class TarrifTicketStore {
  tariffTicket: TariffTicketModel = {}

  constructor() {
    makeAutoObservable(this)
  }

  async getTariffTickets(ticket: TicketItem) {
    if (this.tariffTicket[ticket.tid]) return

    try {
      const abortController = new AbortController()

      this.tariffTicket[ticket.tid] = {
        isLoading: true,
        abortController,
        tickets: [],
      }

      const { data } = await TariffApi.getTariffByTid(
        ticket.tid,
        abortController.signal,
        ticket.uid,
        ticket.it_ref,
      )

      this.tariffTicket[ticket.tid] = {
        isLoading: false,
        abortController,
        tickets: data.data,
      }
    } catch (error) {
      this.tariffTicket[ticket.tid] = {
        tickets: [],
        isLoading: false,
        isError: true,
        abortController: null,
        error: getApiErrorMessage(error) ?? '',
      }
    }
  }
}

export default new TarrifTicketStore()
